import React, { useState } from "react";
import { Autocomplete, Button, Stack, TextField, Typography } from "@mui/material";
import { EventDto, EventWWMember, WWRegistrationDto } from "../../../types/eventTypes";
import useResponsive from "../../../hooks/useResponsive";
import WorkingWeekendSignUpDialog from "./WorkingWeekendSignUpDialog";
import { MembersFieldDto } from "../../../types/membersTypes";

interface AddWorkingWeekendParticipant {
  ww: EventDto;
  members: MembersFieldDto[];
  participants: EventWWMember[];
  signUserUpForWorkingWeekend: (eventId: number, memberId: number, wwRegistration: WWRegistrationDto) => Promise<void>;
}

const AddWorkingWeekendParticipant: React.FunctionComponent<AddWorkingWeekendParticipant> = ({
  ww,
  members,
  participants,
  signUserUpForWorkingWeekend,
}: AddWorkingWeekendParticipant) => {
  const isMobile = useResponsive("down", "sm");
  const [participant, setParticipant] = useState<MembersFieldDto | null>(null);
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Stack
        direction={isMobile ? "column" : "row"}
        alignItems={isMobile ? "start" : "center"}
        spacing={isMobile ? 1 : 0}
      >
        <Typography variant="subtitle1" sx={{ mr: 1 }}>
          Teilnehmer hinzufügen:
        </Typography>
        <Autocomplete
          renderInput={(params) => <TextField variant="outlined" {...params} label="Mitglied" />}
          options={members.filter((member) => !participants.some((p) => p.memberId === member.memberId))}
          getOptionLabel={(option) => `${option.firstname} ${option.lastname}`}
          sx={{ width: 230 }}
          size="small"
          value={participant}
          onChange={(event, newValue) => {
            setParticipant(newValue);
          }}
        />
        <Button
          color="primary"
          size="medium"
          sx={{ ml: isMobile ? 0 : 2 }}
          onClick={handleOpen}
          variant="contained"
          disabled={!participant}
        >
          Hinzufügen
        </Button>
      </Stack>
      <WorkingWeekendSignUpDialog
        open={open}
        handleClose={handleClose}
        ww={ww}
        onSubmit={signUserUpForWorkingWeekend}
        memberId={participant?.memberId ? participant.memberId : -1}
      />
    </>
  );
};

export default AddWorkingWeekendParticipant;
